// extracted by mini-css-extract-plugin
module.exports = {"loaderAnimation":"Level3Advanced_loaderAnimation__2RiaU"};